/* Shows the site-wide pre-order toast once per browser session (not once
 * ever) — a new visit gets told about it again, but it won't re-appear on
 * every page nav within the same visit. Wrapped in try/catch since
 * sessionStorage can throw in some privacy modes; fails open (just shows
 * it) rather than crashing the page over a toast. */
(function () {
  var DISMISS_KEY = "dcPreorderPopupDismissed";

  function alreadyDismissed() {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function remember() {
    try {
      sessionStorage.setItem(DISMISS_KEY, "1");
    } catch (e) {
      /* ignore */
    }
  }

  function init() {
    var el = document.querySelector(".dc-preorder");
    if (!el || alreadyDismissed()) return;

    var closeBtn = el.querySelector(".dc-preorder-close");
    var ctaLink = el.querySelector(".dc-preorder-cta");

    function dismiss() {
      el.classList.remove("is-visible");
      remember();
    }

    if (closeBtn) closeBtn.addEventListener("click", dismiss);
    if (ctaLink) ctaLink.addEventListener("click", remember);

    window.setTimeout(function () {
      el.classList.add("is-visible");
    }, 1200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
